import api from './axios';

export const reportApi = {
  create: (teamMemberId) => api.post('/reports', { teamMemberId }),
  getAll: (params) => api.get('/reports', { params }),
  getById: (id) => api.get(`/reports/${id}`),
  delete: (id) => api.delete(`/reports/${id}`),
};
